import { formatNum } from "../../../../oscar-pos-core/constants";
import { AppTableBody } from "../../../../Libraries";
import Icon from "../../../../assets/Icon";

const ListItem = ({ updatedItems, onChangeQty, key, item, I18n }) => {
  const { id, allocated_qty, discounted_price, product_name, product_image } =
    updatedItems[item.id] || {};

  return (
    <AppTableBody className={"fourColumn"} key={key}>
      <div className="BoxWidth justifyStart productNameBox">
        <p className="productImageBox">
          {product_image ? (
            <img src={product_image} style={{ resize: "cover" }} />
          ) : (
            <Icon
              data={{
                viewBox: "0 0 51 51",
                name: "cameraIcon",
                height: "24px",
                width: "24px",
                fill: "",
              }}
            />
          )}
        </p>
        <p
          className="orderProductName fontSize14 truncateTwoLine darkGrayColor"
          title={product_name}
        >
          {product_name}
        </p>
      </div>
      <div className="BoxWidth justifyCenter">
        <p className="fontSize14 truncateOneLine darkGrayColor">
          Rs. {formatNum(discounted_price)}
        </p>
      </div>
      <div className="BoxWidth justifyCenter mediumBlueBg">
        <div className="inputBoxRightSide">
          <input
            id="edit_order_list_item_qty_input"
            style={{
              textAlign:
                I18n.languageType === "ur" && !allocated_qty
                  ? "center"
                  : "center",
            }}
            value={allocated_qty}
            onChange={(e) => onChangeQty(e.target.value, id)}
          />
          <span className="bar"></span>
        </div>
      </div>
      <div className="BoxWidth justifyCenter">
        <p className="fontSize14 truncateOneLine darkGrayColor">
          Rs. {formatNum(allocated_qty * discounted_price)}
        </p>
      </div>
    </AppTableBody>
  );
};

export default ListItem;
